import React from "react";

const PromosIcon = () => (
  <svg
    style={{ color: "#0f0f0f", fontSize: "16px", width: "16px", height: "16px" }}
    viewBox="0 0 512 512"
  >
    <path d="M456 80H256a24 24 0 0 0-17 7l-30.1 30.1a48 48 0 0 1-33.9 14H56a24 24 0 0 0-24 24v301a24 24 0 0 0 24 24h400a24 24 0 0 0 24-24V104a24 24 0 0 0-24-24ZM176 368a32 32 0 1 1 32-32 32 32 0 0 1-32 32Zm0-160a32 32 0 1 1 32-32 32 32 0 0 1-32 32Zm160 160a32 32 0 1 1 32-32 32 32 0 0 1-32 32Zm0-160a32 32 0 1 1 32-32 32 32 0 0 1-32 32ZM145.2 390.6a16 16 0 0 1-2.6-22.4l192-256a16 16 0 0 1 25.6 19.2l-192 256a16 16 0 0 1-23 3.2Z" />
  </svg>
);

export default PromosIcon;
